import produce from 'immer';
import { AnyAction } from 'redux';
import { NOTIFICATION_ACTIONS } from '../actions/actions';
import { Notification } from '../../types';
import { NotificationState } from '../../types/state';

const initialState: NotificationState = {
  isShownAllMessages: false,
  messages: [],
};

const notificationReducer = (
  state: NotificationState = initialState,
  action: AnyAction
) => {
  switch (action.type) {
    case NOTIFICATION_ACTIONS.SHOW_NOTIFICATION: {
      return produce(state, (draft) => {
        draft.messages = [action.payload as Notification, ...draft.messages];
        draft.isShownAllMessages = false;
      });
    }

    case NOTIFICATION_ACTIONS.HIDE_NOTIFICATION: {
      return produce(state, (draft) => {
        const filteredMessages = draft.messages.filter(
          (toast) => toast.id !== action.payload
        );
        draft.messages = [...filteredMessages];
      });
    }
    default:
      return state;
  }
};

export default notificationReducer;
